import { combineReducers } from 'redux';
import Auth from './Auth';
import Loader from './Loader';
import Notification from './Notification';
import LocalCart from './LocalCart';
import AddToCart from './AddToCart';
import Global from './Global';

const RootReducer = combineReducers({
  Auth,
  Loader,
  Notification,
  LocalCart,
  AddToCart,
  Global
});

export default RootReducer;
